
    export default 
    {
    "market": {
        "placeholder": "Schlüsselwörter für die Suche eingeben",
        "import_to_dsers": "In DSers importieren",
        "import_tip_title": "Bitte wählen Sie eine Filiale aus, um Produkte zu importieren"
    }
}